<header class="flex h-11 min-h-11 items-center justify-between px-3">
  <img
    ngSrc="/brand.svg"
    height="22"
    width="128"
    priority
    class="mx-2"
    [alt]="'top.brandAlt' | ksTranslate"
  />

  <nav [attr.aria-label]="'top.quickActions' | ksTranslate">
    <div class="flex items-center gap-2">
      @for (act of topbarActions; track act.id) {
        <button
          ksIconButton
          ksTooltipPlacement="bottom"
          [iconName]="act.iconName"
          [ariaLabel]="act.label | ksTranslate"
          [ksTooltip]="act.label | ksTranslate"
        ></button>
      }

      @if (user(); as user) {
        <button
          type="button"
          ksTooltipPlacement="bottom"
          ksMenuPlacement="bottom-end"
          class="group/profile size-8 cursor-pointer rounded-full"
          [attr.aria-label]="'top.userProfile' | ksTranslate"
          [ksTooltip]="'top.userProfile' | ksTranslate"
          [ksMenuTrigger]="profileTpl"
        >
          <ks-avatar
            rounded
            decorative
            class="group-hover/profile:opacity-90"
            [src]="user.profileUrl"
            [fallback]="user.fullName | ksInitials"
          />
        </button>
      }
    </div>
  </nav>
</header>

<ng-template #profileTpl>
  <div
    ksMenu
    class="flex w-60 flex-col p-2"
  >
    @if (user(); as user) {
      <div class="flex flex-col items-stretch gap-2 px-3 py-2">
        <div class="flex items-start gap-2">
          <ks-avatar
            size="xl"
            rounded
            decorative
            [src]="user.profileUrl"
            [fallback]="user.fullName | ksInitials"
          />
          <div class="flex flex-auto flex-col items-stretch gap-0.5">
            <div class="label-sm font-medium">{{ user.fullName }}</div>
            <div class="body-xs text-neutral-400">{{ user.company.name }}</div>
          </div>
        </div>
        <div class="body-xs font-medium">{{ user.email }}</div>
      </div>
    }

    <div class="flex flex-col">
      @for (actGroup of profileActionGroups; track $index) {
        <hr ksMenuDivider />

        @for (act of actGroup; track act.id) {
          <button
            ksMenuItem
            ksButton
            variant="menu"
            class="w-full"
            [prefixIconName]="act.iconName"
            [color]="act.color"
            (click)="onAction(act.id)"
          >
            <span class="flex flex-col items-start gap-0.5">
              <span class="label-xs font-medium">{{ act.label | ksTranslate }}</span>

              @if (act.description; as desc) {
                <span
                  class="body-xs text-neutral-400 group-button-hover/button:text-neutral-600 group-button-active/button:text-neutral-200"
                >
                  {{ desc | ksTranslate }}
                </span>
              }
            </span>
          </button>
        }
      }
    </div>
  </div>
</ng-template>
